import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

const Header = () => (
  <header>
    <div className="grid-container grid-container-padded">
      <div className="grid-x">
        <div className="small-7 cell">
          <h1 style={{ margin: 0 }}>
            Ajantasalla
          </h1>
        </div>
        <div className="small-3 cell lang-nav">
          <div>
            <Link to="/" exact activeClassName="active">FI</Link>&nbsp;
            <Link to="/en/" activeClassName="active">ENG</Link>&nbsp;
          </div>
        </div>
      </div>
    </div>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/layouts/header.js